import { MultiplePermissions } from '@firebird-web/acl';

export const MIDDAY_UPDATE_MULTIPLE_PERMISSIONS: MultiplePermissions = [
  ['Midday_Blogs'],
  ['FirstLook'],
  ['Midday_Model_Analysis_Graphics'],
];
